import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getSkuDataAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  skuDataLoader: false,
  uniqueSkuData: [],
  selectedSkuVendorData: [],
  skuDataError: '',
  selectedSkus: [],
  defaultCountry: '',
}

const filterUniqueSkusData = (data, country) => {
  return Object.values(
    data.reduce((skuMap, item) => {
      const { primary_id, vendor_id, vendor_name, ...rest } = item
      if (!skuMap[primary_id]) {
        skuMap[primary_id] = { ...rest, primary_id, vendor_list: [], isSelected: false, country: country }
      }

      const vendor = { vendor_id, vendor_name }
      if (
        !skuMap[primary_id].vendor_list.some(
          (v) => v.vendor_id === vendor_id && v.vendor_name === vendor_name,
        )
      ) {
        skuMap[primary_id].vendor_list.push(vendor)
      }

      return skuMap
    }, {}),
  )
}

export const getSkuForAttachModelSlice = createSlice({
  name: 'get-sku-for-attach-model',
  initialState,
  reducers: {
    setUniqueSkuData: (state, action) => {
      state.uniqueSkuData = action.payload
    },
    setSelectedSkuVendorData: (state, action) => {
      state.selectedSkuVendorData = action.payload
    },
    setSelectedSkus: (state, action) => {
      state.selectedSkus = action.payload
    },
    setDefaultCountry: (state, action) => {
      state.defaultCountry = action.payload
    },
    reset: (state)=>{
     return initialState
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSkuDataAsync.pending), (state) => {
      state.skuDataLoader = true
    })
    builder.addMatcher(isAnyOf(getSkuDataAsync.fulfilled), (state, action) => {
      state.skuDataLoader = false
      const temp = filterUniqueSkusData(action.payload.data, state.defaultCountry)
      state.uniqueSkuData = temp
    })
    builder.addMatcher(isAnyOf(getSkuDataAsync.rejected), (state, action) => {
      state.getSkuTableLoader = false
      state.getSkuTableError = action?.payload?.message
    })
  },
})
export const { setUniqueSkuData, setSelectedSkuVendorData, setSelectedSkus, setDefaultCountry , reset} =
  getSkuForAttachModelSlice.actions
export default getSkuForAttachModelSlice.reducer
